module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/domofon-3-33960980d9ad1e51c38d14a43974bc16.webp";